import {useQuery} from '@tanstack/react-query';
import {getIncomeTaxPdf} from 'presentation/pages/private/my-payments-flow/tab-pages/income-tax/services/getIncomeTaxPdf';
import {GetIncomeTaxPDFParams} from 'domain/usecases';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';

export const useGetIncomeTaxPdfQuery = (params: GetIncomeTaxPDFParams) =>
	useQuery({
		queryKey: [QUERY_KEYS.INCOME_TAX_PDF, params],
		queryFn: async ({signal}) => getIncomeTaxPdf({...params, signal}),
		enabled: false,
	});
